<template>
    <div>
        <el-row :gutter="20">
            <el-col :sm="24" :md="10">
                <div class="invest-totals">
                    <h4>{{$t('planner.TOTALS')}} ({{collection.currency_code}})</h4>
                    <p class="total-asset">{{$t('planner.TotalAssetsAfter10Years')}}</p>
                    <h3
                        class="total-val"
                    >{{savings.currency_symbol}}{{savings.total.amount + savings.total.return | NumFormat }}</h3>
                    <el-row :gutter="12">
                        <el-col :span="12">
                            <div class="total-box">
                                <h5 class="box-title">{{$t('planner.CurrentAllocation')}}</h5>
                                <p>{{savings.currency_symbol}}{{savings.total.amount | NumFormat}}</p>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="total-box">
                                <h5 class="box-title">{{$t('planner.ReturnsForecasted')}}</h5>
                                <p>{{savings.currency_symbol}}{{savings.total.return | NumFormat}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>

            <el-col :sm="24" :md="14">
                <div class="invest-breakdown">
                    <h4>{{$t('planner.WEALTHALLOCATIONBREAKDOWN')}}</h4>
                    <el-row :gutter="20" class="flex-reverse" type="flex">
                        <el-col :sm="12" :xs="24">
                            <ul>
                                <li v-for="(item, index) in tableData" :key="index">
                                    <span class="field-name">{{translations(item.name)}}</span>
                                    <span
                                        class="field-val"
                                    >{{item.amount / totalVal * 100 | FixedNum}}%</span>
                                </li>
                            </ul>
                        </el-col>
                        <el-col :sm="12" :xs="24">
                            <div id="section-breakdown" class="section-breakdown"></div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>

        <div class="invest-table">
            <div class="display-flex mb12 flex-wrap">
                <h3>{{$t('planner.TENYEARRETURNFORECAST')}} ({{collection.currency_symbol}})</h3>
                <div class="btn-group-asset">
                    <el-button
                        type="primary"
                        class="solid-btn white-btn"
                        @click="goTo('adjustForecasts')"
                    >{{$t('planner.AdjustReturnForecasts')}}</el-button>
                    <el-button
                        type="primary"
                        class="solid-btn"
                        @click="goTo('wealthAllocation')"
                    >{{$t('planner.EditAllocations')}}</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                style="width: 100%"
                max-height="550"
                :empty-text="$t('cityRanking.noResult')"
                header-cell-class-name="header-row-style"
            >
                <el-table-column min-width="150" :label="$t('planner.AssetType')">
                    <template slot-scope="scope" prop="name">
                        <span class="tr-title">{{translations(scope.row.name)}}</span>
                        <span
                            class="tr-val"
                        >{{savings.currency_symbol}}{{scope.row.amount | NumFormat }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="120" :label="$t('planner.AnnGrowth')">
                    <template slot-scope="scope" prop="growth">{{scope.row.growth}}%</template>
                </el-table-column>
                <el-table-column min-width="120" :label="$t('planner.AnnYield')">
                    <template slot-scope="scope" prop="growth">{{scope.row.yield}}%</template>
                </el-table-column>
                <el-table-column min-width="150" :label="$t('planner.TenYrTotalReturns')">
                    <template
                        slot-scope="scope"
                        prop="return_percentage"
                    >{{scope.row.return_percentage}}%</template>
                </el-table-column>
                <el-table-column min-width="160" :label="$t('planner.TenYrTotalReturnsAmount')">
                    <template
                        slot-scope="scope"
                        prop="return_accumulated"
                    >{{savings.currency_symbol}}{{scope.row.return_accumulated | NumFormat}}</template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/pie");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

let pieChart, loading;

export default {
    name: "investAsset",
    props: ["collection", "savings"],
    data() {
        const $t = this.$t.bind(this);
        return {
            innerW: window.innerWidth,
            tableData: [],
            pieOptions: {},
            totalVal: 0
        };
    },
    beforeMount() {
        this.savings.cash.name = "Cash";
        this.savings.stocks.name = "Stocks";
        this.savings.bonds.name = "Bonds";
        this.savings.real_estate.name = "Real Estate Equity";
        this.savings.other.name = "Other";
        this.tableData.push(this.savings.cash);
        this.tableData.push(this.savings.stocks);
        this.tableData.push(this.savings.bonds);
        this.tableData.push(this.savings.real_estate);
        this.tableData.push(this.savings.other);
        this.tableData.forEach(it => (this.totalVal += it.amount));
    },

    mounted() {
        this.initialChart();
    },

    methods: {
        initialChart() {
            pieChart = echarts.init(
                document.getElementById("section-breakdown")
            );

            function NumFormat(val) {
                if (!val) return "-";
                val = Number.parseInt(val);
                val = Math.abs(val);
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            let currency = this.savings.currency_symbol;

            this.pieOptions = {
                tooltip: {
                    formatter: function(params) {
                        return `${params.name} (${
                            params.percent
                        }%) <br/> ${currency} ${NumFormat(params.value)}`;
                    },
                    position: "top",
                    textStyle: {
                        borderRadius: 2.3,
                        align: "left",
                        fontFamily: "GothamBook",
                        fontSize: 9
                    }
                },

                series: [
                    {
                        type: "pie",
                        radius: "70%",
                        center: ["50%", "50%"],
                        avoidLabelOverlap: false,
                        selectedMode: "single",
                        minAngle: 30,
                        minShowLabelAngle: "36",
                        data: [],
                        label: {
                            show: false
                        }
                    }
                ],

                color: ["#447ef6", "#9fdbfc", "#052991", "#7076c8", "#8eb0f7"]
            };

            this.tableData.forEach(it => {
                this.pieOptions.series[0].data.push({
                    name: it.name,
                    value: it.amount
                });
            });

            pieChart.setOption(this.pieOptions);
        },

        goTo(tar) {
            this.$emit("goTo", tar);
        },

        translations(val) {
            if (val == "Cash") {
                return this.$t("planner.Cash");
            } else if (val == "Stocks") {
                return this.$t("planner.Stocks");
            } else if (val == "Bonds") {
                return this.$t("planner.Bonds");
            } else if (val == "Real Estate Equity") {
                return this.$t("planner.RealEstate");
            } else if (val == "Other") {
                return this.$t("planner.Other");
            }
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        FixedNum: function(val) {
            if (!val) return "0";
            return val.toFixed(1);
        }
    },

    watch: {},

    components: {}
};
</script>

<style lang="scss">
.invest-totals {
    min-height: 235px;
    border-radius: 6px;
    box-shadow: 0 5px 32px 0 rgba(0, 62, 100, 0.04);
    border: solid 0.9px #e5edf3;
    padding: 18px 20px;
    background-color: #f2f7ff;
    h4 {
        font-family: GothamMedium;
        font-size: 12px;
        color: #333333;
        margin-bottom: 25px;
    }
    .total-asset {
        font-family: GothamBook;
        font-size: 13px;
        color: var(--brownish-grey);
        margin-bottom: 10px;
    }
    .total-val {
        font-family: GothamMedium;
        font-size: 20px;
        line-height: 1;
        letter-spacing: -0.38px;
        color: var(--windows-blue);
        margin-bottom: 19px;
    }
    .total-box {
        border-radius: 2px;
        border: solid 0.6px rgba(46, 91, 255, 0.08);
        background-color: var(--white);
        padding: 18px 12px;
        .box-title {
            line-height: normal;
            font-family: GothamBook;
            margin-bottom: 11px;
            font-size: 11px;
            color: var(--brownish-grey);
        }
        p {
            font-family: GothamMedium;
            font-size: 13px;
            color: #4a4a4a;
        }
    }
}
.invest-breakdown {
    min-height: 235px;
    border-radius: 6px;
    box-shadow: 0 6px 34px 0 rgba(0, 62, 100, 0.04);
    border: solid 0.9px #e5edf3;
    padding: 18px 20px;
    background-color: var(--white);
    @media (max-width: 414px) {
        .flex-reverse {
            flex-direction: column-reverse;
        }
    }
    @media (max-width: 768px) {
        margin-top: 20px;
    }
    h4 {
        font-family: GothamMedium;
        font-size: 12px;
        color: #333333;
        margin-bottom: 20px;
    }
    ul {
        li {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            margin-bottom: 5px;
            padding-left: 40px;
            height: 20px;
            position: relative;
            &::before {
                content: "";
                display: inline-block;
                position: absolute;
                left: 15px;
                top: 5px;
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background-color: #447ef6;
            }

            &:nth-child(2):before {
                background-color: #9fdbfc;
            }

            &:nth-child(3):before {
                background-color: #052991;
            }

            &:nth-child(4):before {
                background-color: #7076c8;
            }

            &:nth-child(5):before {
                background-color: #8eb0f7;
            }

            .field-name {
                font-family: GothamBook;
                font-size: 12px;
                line-height: 1.2;
                letter-spacing: -0.17px;
                color: #30363d;
                margin-bottom: 5px;
                min-height: 20px;
                @media (max-width: 414px) {
                    margin: 0;
                }
            }
            .field-val {
                font-family: GothamBook;
                font-size: 12px;
                line-height: 1.73;
                letter-spacing: -0.17px;
                color: #69737d;
            }
        }
    }
}
.section-breakdown {
    width: 100%;
    height: 130px;
}
.invest-table {
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 5px 32px 0 rgba(0, 62, 100, 0.04);
    border: solid 0.9px #e5edf3;
    background-color: var(--white);
    margin-top: 20px;
    .display-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media (max-width: 414px) {
            &.flex-wrap {
                flex-wrap: wrap;
            }
            .btn-group-asset {
                width: 100%;
                margin-top: 10px;
            }
        }
    }
    .mb12 {
        margin-bottom: 12px;
    }
    h3 {
        font-family: GothamMedium;
        font-size: 12px;
        color: #333333;
        @media (max-width: 768px) {
            max-width: 130px;
        }
        @media (max-width: 414px) {
            max-width: 100%;
            width: 100%;
        }
    }
    .solid-btn {
        box-shadow: none;
        width: auto;
        border-color: var(--windows-blue);
        background-color: var(--windows-blue);
        font-family: GothamBook;
        font-size: 11px;
        color: var(--white);
        border-radius: 2px;
        background-color: var(--windows-blue);
        padding: 0 10px;
        text-align: center;
        &.white-btn {
            background-color: #fff;
            color: var(--windows-blue);
            border: 1px solid var(--windows-blue);
        }
    }
    .header-row-style {
        padding: 5px 0;
        background-color: #f6f9fc;
        .cell {
            font-family: GothamMedium;
            font-size: 11px;
            color: var(--brownish-grey);
            line-height: normal;
        }
    }
    .el-table__row .cell {
        font-family: GothamBook;
        font-size: 13px;
        color: #333333;
        line-height: normal;
    }
    .tr-title {
        font-family: GothamMedium;
        font-size: 13px;
        color: #333333;
        margin-bottom: 5px;
        display: block;
        height: auto;
        line-height: normal;
    }
    .tr-val {
        font-family: GothamBook;
        font-size: 11px;
        color: #333333;
        height: auto;
        line-height: normal;
    }
    @media (max-width: 768px) {
        .el-button {
            width: 108px;
        }
        .el-button.white-btn {
            width: 146px;
        }
    }
    @media (max-width: 414px) {
        .btn-group-asset {
            .el-button {
                width: calc(50% - 3px);
                margin: 0;
                padding: 0;
                text-align: center;
                .white-btn {
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/account/investAsset.vue